import { combineReducers } from 'redux';
import loader from './loader';
import books from './books';
const reducers = combineReducers({
    loader,
    books,
});

export default reducers;


// WEBPACK FOOTER //
// ./src/store/ducks/index.js